<template>
  <sui-page>
    <sui-page-header title="조회화면"></sui-page-header>
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="selectbox"></sui-input-label>
          </div>
          <div class="col-xs-3">
            <sui-select-box :value="{ label: '', key: '' }" :option-list="[{ label: 'select001 ', key: '' }, { label: 'select0002', key: '' }, { label: 'select00003', key: '' }, { label: 'select000000000000004', key: '' }]" placeholder="selectbox">
            </sui-select-box>
            <div class="comp_spacing"></div>
            <sui-text-field placeholder="Input text" default value :disabled="false" :clearable="true" :readonly="false" ></sui-text-field>
          </div>
          <div class="col-xs-1">
            <sui-input-label label="text-field" :required="true" :vertical="false"></sui-input-label>
          </div>
          <div class="col-xs-3">
            <sui-text-field placeholder="Input text" default value :disabled="false" :clearable="true" :readonly="false" ></sui-text-field>
          </div>
          <div class="col-xs-1">
            <sui-input-label label="text-field" :required="true" :vertical="false"></sui-input-label>
          </div>
          <div class="col-xs-3">
            <sui-text-field placeholder="Input text" default value :disabled="false" :clearable="true" :readonly="false" ></sui-text-field>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="checkbox"></sui-input-label>
          </div>
          <div class="col-xs-3">
            <sui-checkbox v-model="multiCheckbox" value="Chk1">Chk1</sui-checkbox>
            <sui-checkbox v-model="multiCheckbox" value="Chk2">Chk2</sui-checkbox>
            <sui-checkbox v-model="multiCheckbox" value="Chk3">Chk3</sui-checkbox>
            <sui-checkbox v-model="multiCheckbox" value="Chk4">Chk4</sui-checkbox>
          </div>
          <div class="col-xs-1">
            <sui-input-label label="radio"></sui-input-label>
          </div>
          <div class="col-xs-3">
            <sui-radio v-model="radioStrValue" value="radio1">Radio 1</sui-radio>
            <sui-radio v-model="radioStrValue" value="radio2">Radio 2</sui-radio>
            <sui-radio v-model="radioStrValue" value="radio3">Radio 3</sui-radio>
          </div>
          <div class="col-xs-1">
            <sui-input-label label="radio"></sui-input-label>
          </div>
          <div class="col-xs-3">
            <sui-radio v-model="radioStrValue" value="radio1">Radio 1</sui-radio>
            <sui-radio v-model="radioStrValue" value="radio2">Radio 2</sui-radio>
            <sui-radio v-model="radioStrValue" value="radio3">Radio 3</sui-radio>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="spin"></sui-input-label>
          </div>
          <div class="col-xs-3">
            <sui-spin :min="0" :step="1" max="10"></sui-spin>
          </div>
          <div class="col-xs-1">
            <sui-input-label label="date"></sui-input-label>
          </div>
          <div class="col-xs-3">
            <sui-date-picker :disabled="false" sticky></sui-date-picker>
          </div>
          <div class="col-xs-1 nodata">
          </div>
          <div class="col-xs-3">
          </div>
        </div>
        <div class="btn_wrap">
          <button type="button" class="comm_btn_Reset ">초기화</button>
          <button type="button" class="comm_btn_Scr">검색</button>
        </div>
      </div>
      <div class="mrB30"></div>
      <sui-grid 
      ref="grid"
      :columns="gridColumns0"
      :dataset="'dataset0'"
      :showMoveControl="true" 
      :columnsautoresize="true"
      :multiselect="true"
      :columnsresize="true"
      :pageable="false" 
      :filtable="true" 
      :sortable="true" 
      :initialPagesize="10"     
      >
      <div class="comp_spacing"></div>
      <div class="btn_wrapL">
         <button type="button" class="comm_btn_gridTop" >행삭제</button>
         <button type="button" class="comm_btn_gridTop">취소</button>
      </div>
      <div class="btn_wrapR">         
         <button type="button" class="comm_btn_gridTop comm_ico_excel" @click="downloadExcel">{{$t('MSG_BTN_EXCEL_DOWN')}}</button>
         <button type="button" class="comm_btn_gridTop_solid" @click="onOpenPopupClick">신규등록</button>
      </div>
    </sui-grid>
    <sui-popup v-model="isShownPopup" title="팝업타이틀">
      <p01 @onClickCancel="onClickCancel" />
    </sui-popup>
    </sui-page-contents>
  </sui-page>
</template>
<script>
  // import - libraries (node modules)
  // import - local files (js, vue, ...)
  // 페이지 에서 사용하는 code 목록 기술
  // import p01 from './Template01_P01';

  const CODE_KEYS = ['COD_PAGE_TYPE'];
  export default {
    name: 'TMP_TEM_001', // eslint-disable-line vue/name-property-casing
    components: {
      // p01,
    },
    data() {
      return {
        // 페이지 에서 사용하는 code 목록이 저장 될 field
        isShownPopup: false,
        multiCheckbox: [],
        radioStrValue: 'radio1',
        codes: {
          COD_MDLE: [{
            label: '',
            key: ''
          }]
        },
        // 이하 data field는 자유롭게
        selectedCodeValue: {
          COD_MDLE: {
            label: '',
            key: ''
          }
        },
        count: 0,
        localdata0: [
          ['', '1', 'Q990-0465656565-001', '수원', 'DISTRIBUTION BOARD-CONSUMER UNIT(UT)', 'P105', '김밍밍', '수원', '2019-04-01', '미정', '미정', '-'],
          ['', '2', 'Q990-0465656565-001', '수원', 'DISTRIBUTION BOARD-CONSUMER UNIT(UT)', 'P105', '김밍밍', '수원', '2019-04-01', '미정', '미정', '-'],
          ['', '3', 'Q990-0465656565-001', '수원', 'DISTRIBUTION BOARD-CONSUMER UNIT(UT)', 'P105', '김밍밍', '수원', '2019-04-01', '미정', '미정', '-'],
          ['', '4', 'Q990-0465656565-001', '수원', 'DISTRIBUTION BOARD-CONSUMER UNIT(UT)', 'P105', '김밍밍', '수원', '2019-04-01', '미정', '미정', '-'],
          ['', '5', 'Q990-0465656565-001', '수원', 'DISTRIBUTION BOARD-CONSUMER UNIT(UT)', 'P105', '김밍밍', '수원', '2019-04-01', '미정', '미정', '-'],
          ['', '6', 'Q990-0465656565-001', '수원', 'DISTRIBUTION BOARD-CONSUMER UNIT(UT)', 'P105', '김밍밍', '수원', '2019-04-01', '미정', '미정', '-'],
          ['', '7', 'Q990-0465656565-001', '수원', 'DISTRIBUTION BOARD-CONSUMER UNIT(UT)', 'P105', '김밍밍', '수원', '2019-04-01', '미정', '미정', '-'],
          ['', '8', 'Q990-0465656565-001', '수원', 'DISTRIBUTION BOARD-CONSUMER UNIT(UT)', 'P105', '김밍밍', '수원', '2019-04-01', '미정', '미정', '-'],
          ['', '9', 'Q990-0465656565-001', '수원', 'DISTRIBUTION BOARD-CONSUMER UNIT(UT)', 'P105', '김밍밍', '수원', '2019-04-01', '미정', '미정', '-'],
          ['', '10', 'Q990-0465656565-001', '수원', 'DISTRIBUTION BOARD-CONSUMER UNIT(UT)', 'P105', '김밍밍', '수원', '2019-04-01', '미정', '미정', '-'],
          ['', '10', 'Q990-0465656565-001', '수원', 'DISTRIBUTION BOARD-CONSUMER UNIT(UT)', 'P105', '김밍밍', '수원', '2019-04-01', '미정', '미정', '-'],
          ['', '12', 'Q990-0465656565-001', '수원', 'DISTRIBUTION BOARD-CONSUMER UNIT(UT)', 'P105', '김밍밍', '수원', '2019-04-01', '미정', '미정', '-'],
          ['', '13', 'Q990-0465656565-001', '수원', 'DISTRIBUTION BOARD-CONSUMER UNIT(UT)', 'P105', '김밍밍', '수원', '2019-04-01', '미정', '미정', '-'],
          ['', '14', 'Q990-0465656565-001', '수원', 'DISTRIBUTION BOARD-CONSUMER UNIT(UT)', 'P105', '김밍밍', '수원', '2019-04-01', '미정', '미정', '-'],
          ['', '15', 'Q990-0465656565-001', '수원', 'DISTRIBUTION BOARD-CONSUMER UNIT(UT)', 'P105', '김밍밍', '수원', '2019-04-01', '미정', '미정', '-'],
          ['', '16', 'Q990-0465656565-001', '수원', 'DISTRIBUTION BOARD-CONSUMER UNIT(UT)', 'P105', '김밍밍', '수원', '2019-04-01', '미정', '미정', '-'],
          ['', '17', 'Q990-0465656565-001', '수원', 'DISTRIBUTION BOARD-CONSUMER UNIT(UT)', 'P105', '김밍밍', '수원', '2019-04-01', '미정', '미정', '-'],
          ['', '18', 'Q990-0465656565-001', '수원', 'DISTRIBUTION BOARD-CONSUMER UNIT(UT)', 'P105', '김밍밍', '수원', '2019-04-01', '미정', '미정', '-'],
          ['', '19', 'Q990-0465656565-001', '수원', 'DISTRIBUTION BOARD-CONSUMER UNIT(UT)', 'P105', '김밍밍', '수원', '2019-04-01', '미정', '미정', '-'],
          ['', '20', 'Q990-0465656565-001', '수원', 'DISTRIBUTION BOARD-CONSUMER UNIT(UT)', 'P105', '김밍밍', '수원', '2019-04-01', '미정', '미정', '-']
        ],
        gridColumns0: [{
          text: 'No.',
          datafield: 'datafield1'
        }, {
          text: '설비ID',
          datafield: 'datafield2'
        }, {
          text: '사업장',
          datafield: 'datafield3'
        }, {
          text: 'Description',
          datafield: 'datafield4'
        }, {
          text: '플랜트',
          datafield: 'datafield5'
        }, {
          text: '채번자',
          datafield: 'datafield6'
        }, {
          text: '대표사업장',
          datafield: 'datafield7'
        }, {
          text: '채번일',
          datafield: 'datafield8'
        }, {
          text: '사업장 설비지정',
          datafield: 'datafield9'
        }, {
          text: 'LC관리대상',
          datafield: 'datafield10'
        }, {
          text: '등록상태',
          datafield: 'datafield11'
        }]
      };
    },
    computed: {},
    watch: {},
    mounted() {},
    beforeUpdate() {},
    updated() {},
    beforeDestroy() {},
    destroyed() {},
    methods: {
      onOpenPopupClick() {
        this.isShownPopup = true;
      },
    },
    datasets: [{
      id: 'dataset0',
      type: 'local',
      data: 'localdata0',
      datafields: [ {
        name: 'datafield1',
        type: 'string',
        map: '1'
      }, {
        name: 'datafield2',
        type: 'string',
        map: '2'
      }, {
        name: 'datafield3',
        type: 'string',
        map: '3'
      }, {
        name: 'datafield4',
        type: 'string',
        map: '4'
      }, {
        name: 'datafield5',
        type: 'string',
        map: '5'
      }, {
        name: 'datafield6',
        type: 'string',
        map: '6'
      }, {
        name: 'datafield7',
        type: 'string',
        map: '7'
      }, {
        name: 'datafield8',
        type: 'string',
        map: '8'
      }, {
        name: 'datafield9',
        type: 'string',
        map: '9'
      }, {
        name: 'datafield10',
        type: 'string',
        map: '10'
      }, {
        name: 'datafield11',
        type: 'string',
        map: '11'
      }]
    }]
  };
</script>
<style scoped>
</style>
